import { render, staticRenderFns } from "./CArticleFooter.vue?vue&type=template&id=5867eb80&"
import script from "./CArticleFooter.vue?vue&type=script&lang=ts&"
export * from "./CArticleFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports